import api from "../../api.js";

export const getUnpaidCodAccounts = () => api.get("/frontshop/debtors/cod/unpaid");

export const getCodOrderDetails = (orderid) =>
  api.get(`/frontshop/debtors/cod/order/${encodeURIComponent(orderid)}`);

export const markCodOrderPaid = (orderid, method) =>
  api.post(`/frontshop/debtors/cod/order/${encodeURIComponent(orderid)}/paid`, { method });
